import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Component({
  selector: 'app-service-codes-scan-custom-cell',
  templateUrl: './service-codes-scan-custom-cell.component.html'
})

export class ServiceCodesScanCustomCellComponent implements OnInit { 
  data: any;
  params: any;
  colorcode: any;
  hideelemet: boolean = false
  constructor(private http: HttpClient, private router: Router) {}

  agInit(params) {
    this.params = params;
    this.data = params.value;

    if(this.data.includes("LOW")){
      this.colorcode = '#008000';
    } 
    if(this.data.includes("HIGH")){
      this.colorcode = '#FF007F';
    } 
    if(this.data.includes("MEDIUM")){
      this.colorcode = '#FF9800';
    }
    if(this.data.includes("ERROR")){
      this.colorcode = '#FF0000';
    }
    if(this.data == "" || this.data == null || this.data == undefined){
      this.hideelemet = true
    }
  }

  ngOnInit() {
    // let element = (<HTMLInputElement>document.getElementById(this.data))
		// if(element != null || element != undefined){
    //   if(this.data.includes("LOW")){
    //     element.style.color = '#008000';
    //   } 
    //   if(this.data.includes("HIGH")){
    //     element.style.color = '#FF007F';
    //   } 
    //   if(this.data.includes("MEDIUM")){
    //     element.style.color = '#FF9800';
    //   }
    //   if(this.data.includes("ERROR")){
    //     element.style.color = '#FF0000';
    //   }
		// }  
  }
}

export type CellAction = (params) => void;